<template>
  <v-row no-gutters>
    <v-col cols="3" class="mt-4">
      <v-label>{{ label }}</v-label>
      <p class="red--text" v-if="!value">Rule turned off</p>
    </v-col>
    <v-col cols="2">
      <v-text-field v-model="interval" type="number" class="mr-2" min="1"></v-text-field>
    </v-col>
    <v-col cols="2">
      <v-select :items="intervalPeriods" v-model="intervalPeriod"></v-select>
    </v-col>
    <v-col cols="4" class="mt-2 ml-4">
      <p>{{ description }} {{ interval || 'N'}} {{ intervalPeriod }}</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'interval-input',
  props: {
    value: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      interval: null,
      intervalPeriod: 'days',
      intervalPeriods: ['days', 'months']
    }
  },

  watch: {
    value: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal) {
          [this.interval, this.intervalPeriod] = newVal.toString().split(' ')
        }
      }
    },
    interval (newVal, oldVal) {
      if (newVal) {
        this.$emit('input', `${newVal} ${this.intervalPeriod}`)
      } else {
        this.$emit('input', null)
      }
    },
    intervalPeriod (newVal, oldVal) {
      if (this.interval) {
        this.$emit('input', `${this.interval} ${newVal}`)
      } else {
        this.$emit('input', null)
      }
    }
  }

}
</script>
